import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { FIRST_PARTY_REPORT_ID } from './firstPartyReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.AUDIENCE_NAME.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.AUDIENCE_SOURCE.field,
        FIELDS.STATUS.field,
        FIELDS.AUDIENCE_SIZE.field,
        FIELDS.AUDIENCE_CAMPAIGN_USING.field,
        FIELDS.AUDIENCE_MATCH_RATE.field,
        FIELDS.LAST_MODIFY_BY.field,
        FIELDS.LAST_MODIFY_ON.field,
        FIELDS.LAST_REFRESHED.field,
    ].map(field => generateColumnId(FIRST_PARTY_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.AUDIENCE_SOURCE.field,
    FIELDS.STATUS.field,
    FIELDS.AUDIENCE_SIZE.field,
    FIELDS.AUDIENCE_CAMPAIGN_USING.field,
    FIELDS.AUDIENCE_MATCH_RATE.field,
    FIELDS.LAST_MODIFY_BY.field,
    FIELDS.LAST_MODIFY_ON.field,
    FIELDS.ACTIONS_COLUMN.field,
    FIELDS.LAST_REFRESHED.field,
].map(field => generateColumnId(FIRST_PARTY_REPORT_ID, field));

export { customColumns, defaultColumns };
